import * as React from 'react'
import { useShowContext, SimpleShowLayout, Show, useTranslate } from 'react-admin'
import { Grid, Container } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { HasPermission } from 'src/helper/HasPermission'

const ShowWrapper = ({ children }) => <Container maxWidth='false'> {children}</Container>

const ShowContent = () => {
  const translate = useTranslate()
  const { error, isLoading, record } = useShowContext()

  const accountingTypes = [
    { id: 3, name: 'Prestadores Cia Aéreas'},
    { id: 5, name: 'Prestadores internacionales' },
    { id: 4, name: 'Prestadores nacionales'}
  ]

  const supplierTypes = [
    { id: 1, name: 'Aéreo' },
    { id: 2, name: 'Hotel' },
    { id: 3, name: 'Otros prestadores turísticos'}
  ]

  if (isLoading) {
    return <div>{translate('ra.action.loading')}</div>
  }
  if (error) {
    return <div>{translate('ra.notification.http_error')}</div>
  }

  return (
    <SimpleShowLayout>
      <CardCommon title={translate('ra.entity.supplier')} actions={<CardCrudBottomButtons btnEdit={true} />}>
        <CardCommon title={translate('ra.title.basic_data')} actions={null} style={{ width: '100%' }}>
          <Grid container spacing={3}>
            <ShowListElement label={translate('ra.field.id')} value={record?.id} />
            <ShowListElement label={translate('ra.field.name')} value={record?.name} />
            <ShowListElement label={translate('ra.field.code')} value={record?.code} />
            <ShowListElement label={translate('ra.field.tma_code')} value={record?.billing_code} />
            <ShowListElement label={translate('ra.field.currency')} value={record?.currency_relation?.long_name} />
            <ShowListElement label={translate('ra.field.country')} value={record?.country_relation?.long_name} />
            <ShowListElement
              label={translate('ra.field.is_active')}
              value={record?.is_active}
              type='boolean'
            />
          </Grid>
        </CardCommon>
º
        <HasPermission permission='fiscal_data' resource={'supplier'}>
          <CardCommon title={translate('ra.title.fiscal_data')} actions={null} style={{ width: '100%', 'margin-top': 32 }}>
            <Grid container spacing={3}>
              <ShowListElement label={translate('ra.field.business_name')} value={record?.fiscal_data_relation?.name} />
              <ShowListElement label={translate('ra.field.document_type')} value={record?.fiscal_data_relation?.document_type_relation?.short_name} />
              <ShowListElement label={translate('ra.field.document_number')} value={record?.fiscal_data_relation?.document_number} />
              <ShowListElement label={translate('ra.field.type_responsible')} value={record?.fiscal_data_relation?.type_responsible_relation?.name} />
              {/* <ShowListElement
                label={translate('ra.field.accounting_config_code')}
                value={accountingTypes.find(elem => elem.id === record?.fiscal_data_relation?.accounting_config_code)?.name}
              /> */}
            </Grid>
          </CardCommon>
        </HasPermission>

        <CardCommon title={translate('ra.title.contact')} actions={null} style={{ width: '100%', 'margin-top': 32 }}>
          <Grid container spacing={3}>
            <ShowListElement label={translate('ra.field.email')} value={record?.email} />
            <ShowListElement label={translate('ra.field.phone')} value={record?.phone} />
          </Grid>
        </CardCommon>

        <CardCommon title={translate('ra.title.configuration')} actions={null} style={{ width: '100%', 'margin-top': 32 }}>
          <Grid container spacing={3}>
            <ShowListElement label={translate('ra.field.due_date_method')} value={record?.due_date_method_relation?.name} />
            <ShowListElement
              label={translate('ra.field.product-type')}
              value={record?.product_type_relation}
              optionValue='long_name'
              type='array'
            />
            <ShowListElement label={translate('ra.field.gmx_contract_id')} value={record?.gmx_contract_id} />
          </Grid>
        </CardCommon>
      </CardCommon>
    </SimpleShowLayout>
  )
}

export const SupplierShow = (props) => {
  return (
    <Show component={ShowWrapper} {...props} actions={null} className='CrudShowContainer'>
      <ShowContent {...props} />
    </Show>
  )
}
